export const QUALITY_STATUSES = {
  CREATED: 'Created',
  APPROVED: 'Approved',
  REJECTED: 'rejected',
  CONDITIONALLY_APPROVED: 'Conditionally Approved',
  EVIDENCE_REQUESTED: 'Evidence Requested',
};

export const QUALITY_STATUS_ID = {
  CREATED: 1,
  APPROVED: 2,
  REJECTED: 3,
  CONDITIONALLY_APPROVED: 4,
  EVIDENCE_REQUESTED: 5,
};
export const QUALITY_STATUS_NAMES = {
  1: QUALITY_STATUSES.CREATED,
  2: QUALITY_STATUSES.APPROVED,
  3: QUALITY_STATUSES.REJECTED,
  4: QUALITY_STATUSES.CONDITIONALLY_APPROVED,
  5: QUALITY_STATUSES.EVIDENCE_REQUESTED,
};

export const QUALITY_STATUSES_COLORS = {
  WARNING: 'label-warning',
  SUCCESS: 'label-success',
  DANGER: 'label-danger',
  INFO: 'label-info',
  SECONDARY: 'label-secondary',
};

export const PRODUCTION_PRINT_ACTIONS = {
  PRINT_LABEL: 'print-label',
  SCAN_LABEL: 'scan-label',
  REPRINT_LABEL: 'reprint-label',
  LOST_LABEL_REPRINT: 'lost-label-reprint',
  PRINT_NOTIN_PRODUCTION: 'print-not-in-production',
  PRINT_CUSTOM_QUANTITY_LABEL: 'print-custom-quantity-label',
  LABEL_QUANTITY_SPLITTER: 'label-quantity-splitter',
  PRINT_SCRAP_CATALOG: 'print-scrap-catalog',
};

export const SHIPMENT_OPERATIONS = {
  PICK_TICKET: 'PickTicket',
  LABEL: 'Label',
  BOL: 'BOL',
  MANIFEST: 'Manifest',
  PACKING_SLIP: 'PackingSlip',
};

export const ACTION_MODE = {
  VIEW: 'View',
  COPY_TO_CELL: 'CopyToCell',
  ADD: 'Add',
};
